module.exports = (__webpack_require__(26))(195);


//////////////////
// WEBPACK FOOTER
// delegated ./src/pluginUtils.js from dll-reference girder_plugin_large_image
// module id = 152
// module chunks = 0